import { AutogenModelEftFileNum, AutogenRowEftFileNum } from "./autogen/AutogenModelEftFileNum";

export class ModelEftFileNum extends AutogenModelEftFileNum<RowEftFileNum> {
	constructor() {
		super(RowEftFileNum);
	}
}

export class RowEftFileNum extends AutogenRowEftFileNum {
}